
require("./../../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
/* eslint-disable import/no-named-as-default-member */
import { GetServerSideProps } from 'next';
import MainLayout from 'global/MainLayout';
import PageLoader from 'global/Loading/PageLoader';
import useProtectedRoute from 'hooks/useProtectedRoute';
import SEO from 'global/SEO';
import liveStreamApi from 'lib/api/livestream';
import dynamic from 'next/dynamic';

const LiveStream = dynamic(() => import('features/event/livestream'), {
  ssr: false,
});

interface EventPageProps {
  eventId: string;
  head: any;
}

function EventPage({ eventId, head }: EventPageProps) {
  const { isLoaded } = useProtectedRoute();

  return (
    <MainLayout isFlexibleWidth background="white">
      <SEO {...head} />
      <PageLoader loaded={isLoaded} />
      <LiveStream eventId={eventId} />
    </MainLayout>
  );
}

export default EventPage;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const head: any = {};
  let isError = false;
  await liveStreamApi
    .getEventNonLogin(context.query?.id)
    .then((res) => {
      const { data } = res.data;
      if (data) {
        head.title = data.title;
        head.description = data.description;
        head.image = data.media.thumbnail_url;
      }
    })
    .catch(() => {
      isError = true;
    });
  return {
    props: {
      eventId: context.query?.id,
      isError,
      head,
    },
  };
};
